const INITIAL_STATE = {
  foto: null,
  show: false,
  code: null,
  esperandoSolicitacao: false,
  validade: null,
  urlValidacao: null,
  beneficiosCarteira: [],
  checkCiente: false,
  error: false,
  esperandoDownload: false,
  mensagem: ''
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CARTEIRA_INIT':
      return { ...state, error: false, mensagem: '', esperandoSolicitacao: false, checkCiente: false }
    case 'CARTEIRA_SET_BENEFICIOS_CARTEIRA':
      return { ...state, beneficiosCarteira: action.payload.beneficios, 
        validade: action.payload.validade, esperandoSolicitacao: false, checkCiente: false }
    case 'CARTEIRA_SET_FOTO':
      return { ...state, foto: action.payload }
    case 'CARTEIRA_SET_CHECK_CIENTE':
      return { ...state, checkCiente: action.payload }
    case 'CARTEIRA_SET_SHOW':
      return { ...state, show: action.payload }
    case 'CARTEIRA_INIT_BUSCA_FOTO':
      return { ...state, esperandoSolicitacao: true }
    case 'CARTEIRA_BUSCA_FOTO_SUCESSO':{
      if (action.payload && action.payload.fotoBase64) {
        return { ...state, code: action.payload.codigo, esperandoSolicitacao: false,
          urlValidacao: action.payload.urlReimpressao,
          foto: `data:image/jpeg;base64,${action.payload.fotoBase64}`}
      } else {
        return { ...state, esperandoSolicitacao: false }
      }
    }
    case 'CARTEIRA_BUSCA_FOTO_ERROR':
      return { ...state, error: true, esperandoSolicitacao: false }
    case 'CARTEIRA_INIT_INCLUIR_FOTO':
      return { ...state, esperandoSolicitacao: true }
    case 'CARTEIRA_INCLUIR_FOTO_SUCESSO':
      return { ...state, code: action.payload.codigo, esperandoSolicitacao: false,
        urlValidacao: action.payload.urlReimpressao, 
        foto: `data:image/jpeg;base64,${action.payload.fotoBase64}`}
    case 'CARTEIRA_INCLUIR_FOTO_ERROR':
      return { ...state, esperandoSolicitacao: false }
    case 'CARTEIRA_IMPRESSAO_SOLICITADA':
      return { ...state, esperandoDownload: true }
    case 'CARTEIRA_PDF_RECEBIDO':
    case 'CARTEIRA_IMPRESSAO_ERRO':
      return { ...state, esperandoDownload: false }
    case 'CARTEIRA_INIT_DELETE_FOTO':
      return { ...state, esperandoSolicitacao: true }
    case 'CARTEIRA_DELETE_FOTO_SUCESSO':{
      if (action.payload) {
        return { ...state, code: action.payload.codigo, esperandoSolicitacao: false,}
      } else {
        return { ...state, esperandoSolicitacao: false }
      }
    }
    case 'CARTEIRA_DELETE_FOTO_ERROR':
      return { ...state, error: true, esperandoSolicitacao: false }  
    default:
      return state
  }
}
